import {defaultsDeep} from 'es-toolkit/compat'

import defaultConfig from './default'

export default defaultsDeep(
  {
    sentry: {
      enabled: true,
      environment: 'staging',
    },
  },
  defaultConfig
)
